import { request } from '@/store/client'
import { ResetPasswordState } from '@/types'

export const requestResetPassword = (email: string): Promise<ResetPasswordState> => {
  const encodedEmail = encodeURIComponent(email)

  return request({
    url: `/user/${encodedEmail}/reset-password`,
    method: 'post',
  }).then((response) => {
    return response.data.state as ResetPasswordState
  })
}
